import React, { useEffect, useState } from "react";
import "./Verificationpage.scss";
import { auth, sendEmailVerification } from "../../../features/firebase";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Verificationpage = ({ user }) => {
  const [seconds, setSeconds] = useState(30);
  const [isCounting, setIsCounting] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    const timer = setTimeout(() => setError(""), 2000);

    return () => clearTimeout(timer);
  }, [user, navigate]);

  useEffect(() => {
    const savedTime = localStorage.getItem("countdownEndTime");
    const emailSentStatus = localStorage.getItem("emailSent");

    if (savedTime) {
      const endTime = new Date(parseInt(savedTime, 10));
      const remainingTime = Math.max(
        0,
        Math.floor((endTime - new Date()) / 1000)
      );
      if (remainingTime > 0) {
        setSeconds(remainingTime);
        setIsCounting(true);
        setIsButtonDisabled(true);
      } else {
        localStorage.removeItem("countdownEndTime");
      }
    }

    if (emailSentStatus === "true") {
      setEmailSent(true);
    }
  }, []);

  useEffect(() => {
    if (isCounting) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds <= 1) {
            clearInterval(timer);
            setIsCounting(false);
            setIsButtonDisabled(false);
            localStorage.removeItem("countdownEndTime");
            localStorage.removeItem("emailSent");
            setEmailSent(false);
            return 30;
          }
          return prevSeconds - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isCounting]);

  const startTimer = () => {
    setIsCounting(true);
    setIsButtonDisabled(true);
    const endTime = new Date(Date.now() + 30 * 1000);
    localStorage.setItem("countdownEndTime", endTime.getTime().toString());
  };

  const sendVerificationEmail = async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      try {
        await sendEmailVerification(currentUser);
        setEmailSent(true);
        localStorage.setItem("emailSent", "true");
        startTimer();
        navigate("/verifikasi/autentikasi-akhir");
      } catch (error) {
        console.error("Error sending verification email:", error);
        if (error.code === "auth/too-many-requests") {
          setError("Terlalu banyak permintaan coba lagi nanti");
        }
      }
    } else {
      console.log("No user is signed in.");
    }
  };

  const openNewPage = () => {
    window.open("https://mail.google.com/", "_blank");
  };

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="verification-page"
    >
      <div className="verification-box">
        {error ? (
          <h1>{error}</h1>
        ) : (
          <h1>
            {user.emailVerified
              ? "Kamu sudah melakukan verifikasi di "
              : "Lakukan Verifikasi di "}
            Akun <span>{user.email}</span>
          </h1>
        )}

        {!user.emailVerified ? (
          <>
            {emailSent ? (
              <p style={{ color: "#40ff00" }}>
                Verifikasi telah dikirim, cek email kamu sekarang
              </p>
            ) : (
              <p>Tekan tombol di bawah untuk kirim verifikasi email</p>
            )}
          </>
        ) : (
          ""
        )}

        <button
          className="send-verif"
          onClick={sendVerificationEmail}
          disabled={isButtonDisabled || user.emailVerified}
        >
          {user.emailVerified
            ? "Akun Sudah Terverifikasi"
            : isButtonDisabled
            ? `Tunggu ${seconds} detik lagi`
            : "Kirim Email Verifikasi"}
        </button>

        {user.emailVerified ? (
          <p id="opm" onClick={() => navigate("/")}>
            Kembali ke homepage
          </p>
        ) : (
          <p id="opm" onClick={openNewPage}>
            Buka Email Kamu, khusus web
          </p>
        )}
      </div>
      <div className="logo-powered-verif">
        <h4>Project Powered</h4>
        <div className="honk">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/3/37/Firebase_Logo.svg"
            alt="firebase"
          />
          <img
            id="gomgol"
            src="https://download.logo.wine/logo/Google/Google-Logo.wine.png"
            alt="google"
          />
          <svg
            aria-label="Vercel logotype"
            height="104"
            role="img"
            viewBox="0 0 283 64"
            width="100"
          >
            <path
              d="M141.68 16.25c-11.04 0-19 7.2-19 18s8.96 18 20 18c6.67 0 12.55-2.64 16.19-7.09l-7.65-4.42c-2.02 2.21-5.09 3.5-8.54 3.5-4.79 0-8.86-2.5-10.37-6.5h28.02c.22-1.12.35-2.28.35-3.5 0-10.79-7.96-17.99-19-17.99zm-9.46 14.5c1.25-3.99 4.67-6.5 9.45-6.5 4.79 0 8.21 2.51 9.45 6.5h-18.9zm117.14-14.5c-11.04 0-19 7.2-19 18s8.96 18 20 18c6.67 0 12.55-2.64 16.19-7.09l-7.65-4.42c-2.02 2.21-5.09 3.5-8.54 3.5-4.79 0-8.86-2.5-10.37-6.5h28.02c.22-1.12.35-2.28.35-3.5 0-10.79-7.96-17.99-19-17.99zm-9.45 14.5c1.25-3.99 4.67-6.5 9.45-6.5 4.79 0 8.21 2.51 9.45 6.5h-18.9zm-39.03 3.5c0 6 3.92 10 10 10 4.12 0 7.21-1.87 8.8-4.92l7.68 4.43c-3.18 5.3-9.14 8.49-16.48 8.49-11.05 0-19-7.2-19-18s7.96-18 19-18c7.34 0 13.29 3.19 16.48 8.49l-7.68 4.43c-1.59-3.05-4.68-4.92-8.8-4.92-6.07 0-10 4-10 10zm82.48-29v46h-9v-46h9zM37.59.25l36.95 64H.64l36.95-64zm92.38 5l-27.71 48-27.71-48h10.39l17.32 30 17.32-30h10.39zm58.91 12v9.69c-1-.29-2.06-.49-3.2-.49-5.81 0-10 4-10 10v14.8h-9v-34h9v9.2c0-5.08 5.91-9.2 13.2-9.2z"
              fill="black"
            ></path>
          </svg>
          <div className="github-logo">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg"
              alt="github"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/29/GitHub_logo_2013.svg"
              alt="github"
            />
          </div>
        </div>
      </div>
    </motion.main>
  );
};

export default Verificationpage;
